import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";

export const fetchProviderStart = () => {
  return {
    type: actionTypes.FETCH_PROVIDER_DETAILS_START,
  };
};
export const fetchProviderSuccess = (provider) => {
  return {
    type: actionTypes.FETCH_PROVIDER_DETAILS_SUCCESS,
    provider: provider,
  };
};
export const fetchProviderFailed = (error) => {
  return {
    type: actionTypes.FETCH_PROVIDER_DETAILS_FAILED,
    payload: error,
  };
};

export const fetchProvider = (
  providerId: string,
  npi: string,
  distance: number,
  postalCode: string,
  orgDistance: string,
  contractStatus: string
) => {
  const favProvider = {
    userId: localStorage.getItem("userId"),
    providerId: providerId,
  };
  return (dispatch) => {
    console.log("providerId", favProvider);
    dispatch(fetchProviderStart());
    const baseUrl = serverconfigs.fetchProviderUrl+`/${providerId}/${localStorage.getItem("userId")}?distance=${distance}&postalCode=${postalCode}
    &orgDistance=${orgDistance}&npi=${npi}&clientGroupId=${localStorage.getItem("clientGroupId")}&clientId=${localStorage.getItem("clientId")}`

    const detailUrl = contractStatus.length>0 ? baseUrl.concat(`&contractStatus=${contractStatus}`):baseUrl
    axios
      .get(
        // `/provider/detail/${providerId}/${localStorage.getItem(
        //   "userId"
        // )}?providerTypeId=${providerTypeId}&specialtyId=${specialtyId}`
        detailUrl
      )
      .then((response) => {
        // console.log(response.data);
        if (response.data.result.length > 0) {
          dispatch(fetchProviderSuccess(response.data.result[0]));
        } else {
          dispatch(fetchProviderSuccess(null));
        }
      })
      .catch((error) => {
        if (error.statusCode === 400) {
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
        }
        dispatch(fetchProviderFailed(error));
      });
  };
};
